import {filter} from 'lodash';
import {
    EXAM_TYPE_EGE,
    EXAM_INNER_TEST,
    EXAM_MEDIUM_BALL_FROM_DOC,
    EXAM_ACCREDITATION,
} from '@assets/js/constants/examsResults';
import {
    APPLICANT_LEVEL_CERTIFICATE_CARD,
    APPLICANT_LEVEL_EDU_BASIC_PROF_DIPLOMA,
    APPLICANT_LEVEL_EDU_BASIC,
    APPLICANT_LEVEL_EDU_SECONDARY,
    APPLICANT_LEVEL_EDU_SPO,
    APPLICANT_LEVEL_EDU_VO,
} from '../constants/diploma';

export const filterExamTypesByDiplomaId = (configExamTypes, diplomaId) => {
    return configExamTypes.filter((type) => {
        if (diplomaId === APPLICANT_LEVEL_CERTIFICATE_CARD || diplomaId === APPLICANT_LEVEL_EDU_BASIC_PROF_DIPLOMA) {
            const allowedTypes = [EXAM_INNER_TEST];
            return allowedTypes.indexOf(type.value) !== -1;
        }
        if (diplomaId === APPLICANT_LEVEL_EDU_BASIC) {
            const allowedTypes = [EXAM_INNER_TEST, EXAM_MEDIUM_BALL_FROM_DOC];
            return allowedTypes.indexOf(type.value) !== -1;
        }
        if (diplomaId === APPLICANT_LEVEL_EDU_SECONDARY || diplomaId === APPLICANT_LEVEL_EDU_SPO) {
            const allowedTypes = [EXAM_TYPE_EGE, EXAM_INNER_TEST, EXAM_MEDIUM_BALL_FROM_DOC];
            return allowedTypes.indexOf(type.value) !== -1;
        }
        if (diplomaId === APPLICANT_LEVEL_EDU_VO || diplomaId === APPLICANT_LEVEL_EDU_SPO) {
            const allowedTypes = [
                EXAM_TYPE_EGE,
                EXAM_INNER_TEST,
                EXAM_ACCREDITATION,
            ];
            return allowedTypes.indexOf(type.value) !== -1;
        }
    });
};

export const filterExamTypesByContestExamTypes = (configExamTypes, contestExamTypes) => {
    return configExamTypes.filter((configExamType) => {
        return contestExamTypes.indexOf(configExamType.value) !== -1;
    });
};

export const filterSprCompetitionsZajavls = (list, filterContainer) => {
    return filter(list, filterContainer);
};
